import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "import",
  "use": "import-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"import\"><defs><style>#import .cls-1{fill:none}</style></defs><title>资源 56</title><g id=\"import_图层_2\" data-name=\"图层 2\"><g id=\"import_图层_1-2\" data-name=\"图层 1\"><g id=\"import_upload\"><path id=\"import_Shape\" d=\"M3 22.5A1.46 1.46 0 0 1 1.5 21v-5.18a.81.81 0 0 1 1.62-.06v4.64a.48.48 0 0 0 .48.48h16.8a.47.47 0 0 0 .48-.48v-4.58a.81.81 0 1 1 1.62 0v5.23a1.45 1.45 0 0 1-1.45 1.45H3zm8.25-4.69V4.27L8.94 6.54A.81.81 0 0 1 7.8 5.39l3.65-3.65a.81.81 0 0 1 1.15 0l3.65 3.65a.81.81 0 0 1 0 1.15.83.83 0 0 1-1.15 0l-2.26-2.27v13.54a.82.82 0 0 1-.82.81.81.81 0 0 1-.81-.81z\" /></g><path id=\"import_Rectangle_49\" data-name=\"Rectangle 49\" class=\"cls-1\" d=\"M0 0h24v24H0z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/import.svg
// module id = aYs0
// module chunks = 6